import React from 'react';
import { useTranslation } from 'react-i18next';
import ContentPage from 'src/components/ContentPage/ContentPage';
import ReportingLinkList from 'src/features/siva/reporting/components/ReportingLinkList/ReportingLinkList';
import { ROUTES } from 'src/navigation';

const ExtractOverview: React.FC = () => {
  const { t: tSiva } = useTranslation('siva');
  const { t: tPageTitles } = useTranslation('pageTitles');

  return (
    <ContentPage title={tSiva('dataExtract')} documentTitle={tPageTitles('sivaDataExtract')}>
      <ReportingLinkList
        items={[
          { to: ROUTES.SIVA.ADMIN.EXTRACT.GOALS, title: tSiva('targetNumber') },
          {
            to: ROUTES.SIVA.ADMIN.EXTRACT.GOALACCOMPLISHMENT,
            title: tSiva('company.details.sidenav.GoalAchievement'),
          },
          {
            to: ROUTES.SIVA.ADMIN.EXTRACT.IDEAS_AND_COMPANIES,
            title: tSiva('ideasAndCompanies.title'),
          },
          { to: ROUTES.SIVA.ADMIN.EXTRACT.KTU, title: tSiva('export.ktu.header') },
        ]}
      />
    </ContentPage>
  );
};

export default ExtractOverview;
